import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React, {FC, useState} from 'react';
import {Text} from '../../../../atoms/Text/Text';
import {
  AttributeFilterItem,
  AttributeItems,
} from '../../FilterContent/Attribute/AttributeItems';
import {useFilteredAttributeItems} from '../../FilterContent/Attribute/useFilteredAttributeItems';
import {GenericFilterSearchField} from '../../FilterContent/Shared/GenericSearchField';
import {FilterDropdown} from '../FilterDropdown';

interface Props {
  activeItemIds: Array<string>;
  dataTestId?: string;
  items: Array<AttributeFilterItem>;
  label: string;
  headline?: string;
  description?: string;
  isSingleSelect?: boolean;
  onAttributeClick: (itemId: string, itemSlug?: string) => void;
  onFilterReset: () => void;
  onOpen?: () => void;
  onClose?: () => void;
  shouldDisplaySearchField?: boolean;
  padContent?: boolean;
}

export const FilterDropdownGeneric: FC<Props> = ({
  activeItemIds,
  items,
  label,
  headline,
  description,
  isSingleSelect,
  onAttributeClick,
  onFilterReset,
  onOpen,
  onClose,
  shouldDisplaySearchField = false,
  padContent = true,
}) => {
  const {t} = useTranslation();
  const [search, setSearch] = useState('');

  const onCloseGenericFilter = () => {
    setSearch('');
    onClose && onClose();
  };

  const filteredAttributeItems = useFilteredAttributeItems({
    search,
    shouldFilter: shouldDisplaySearchField,
    attributeItems: items,
  });

  return (
    <FilterDropdown
      dataTestId="filterDropdownAttribute"
      activeCount={activeItemIds.length}
      label={label}
      onReset={onFilterReset}
      onClose={onCloseGenericFilter}
      onOpen={onOpen}
      padContent={padContent}
      filterContent={
        <div>
          {shouldDisplaySearchField && (
            <GenericFilterSearchField
              search={search}
              searchPlaceholder={t('Search for {label}', {label})}
              setSearch={setSearch}
            />
          )}
          {(headline || description) && (
            <HeadlineWrapper>
              <Text size="px12" color="Grey1">
                {description}
              </Text>
              <Text size="px14">{headline}</Text>
            </HeadlineWrapper>
          )}

          <AttributeItems
            dataTestId="filterDropdownGeneric"
            items={filteredAttributeItems}
            activeItemIds={activeItemIds}
            onAttributeClick={onAttributeClick}
            isSingleSelect={isSingleSelect}
          />
        </div>
      }
      showScrollFade
    />
  );
};

const HeadlineWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 24px 4px 24px;
`;
